<template>
  <div>
    <BaseLoader v-if="loading" />
    <div v-if="!loading">
      <el-dialog
        :show-close="false"
        :visible.sync="reportClipDialog"
        width="515px">
        <template slot="title">
          <div class="modal-title acr-bold-22">
            <div>
              <div class="modal-btn" @click="reportClipDialog = false">
                <svgicon name="Chevron-left"></svgicon>
              </div>
              <span style="margin-top: -1px">Send a report</span>
            </div>
            <div class="modal-btn" :class="{'active': reportReasons.length > 0}" @click="reportIssue">
              <svgicon name="Arrow-right"></svgicon>
            </div>
          </div>
        </template>
        <div class="modal-reasons">
          <el-checkbox-group v-model="reportReasons">
            <el-checkbox label="The video clip was not trimmed correctly"><span class="acr-medium">The video clip was not trimmed correctly</span></el-checkbox>
            <el-checkbox label="Some objects were not detected"><span class="acr-medium">Some objects were not detected</span></el-checkbox>
            <el-checkbox label="Some objects were detected incorrectly"><span class="acr-medium">Some objects were detected incorrectly</span></el-checkbox>
            <el-checkbox label="Wrong tag"><span class="acr-medium">Wrong tag</span></el-checkbox>
          </el-checkbox-group>
          <input type="text" style="margin-top: 25px;height: 30px;width: 100%">
        </div>
      </el-dialog>
      <el-dialog
        :show-close="false"
        :visible.sync="addTagModal"
        width="588px">
        <template slot="title">
          <div class="modal-title acr-bold-22">
            <div>
              <div class="modal-btn" @click="addTagModal = false">
                <svgicon name="Chevron-left"></svgicon>
              </div>
              <span style="margin-top: -1px">Add new tag(s)</span>
            </div>
            <div class="modal-btn" :class="{'active': newTag.length > 0 || tagsToAdd.length > 0}" @click="addTags">
              <svgicon name="Arrow-right"></svgicon>
            </div>
          </div>
        </template>
        <div class="modal-tags">
          <div>
            <div class="filter__subtitle acr-medium-18">Scenes</div>
            <div>
              <el-checkbox-group v-model="tagsToAdd">
                <el-checkbox
                  :label="values.label"
                  v-for="values in filters" :key="values.value"><span class="acr-medium">{{ values.label.toUpperCase() }}</span></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div v-for="filter in asideFilters" :key="filter.item_label" style="display: flex;flex-direction: column">
            <div class="filter__subtitle acr-medium-18" v-if="filter.item_label">{{filter.item_label}}</div>
            <el-checkbox-group v-model="tagsToAdd">
              <el-checkbox
                dark
                :label="item"
                v-for="item in filter.filter_values" :key="item"><span class="acr-medium">{{truncateString(item, 25)}}</span></el-checkbox>
            </el-checkbox-group>
          </div>
          <input type="text" placeholder="or write new one" v-model="newTag">
        </div>
      </el-dialog>
      <el-dialog
        :show-close="false"
        :visible.sync="deleteDetectModal"
        width="788px">
        <template slot="title">
          <div class="modal-title acr-bold-22">
            <div>
              <div class="modal-btn" @click="deleteDetectModal = false">
                <svgicon name="Chevron-left"></svgicon>
              </div>
              <span style="margin-top: -1px">Are you sure you want to delete selected detect?</span>
            </div>
            <div class="modal-btn active" @click="deleteBoundingBox">
              <svgicon name="Arrow-right"></svgicon>
            </div>
          </div>
        </template>
        <!-- <div class="projects-table" v-if="selectedProjects" style="padding: 0;min-height: unset">
          <div class="projects-table-item np" v-for="item in selectedProjects" :key="item.id">
            <div class="projects-table-item__name">
              <svgicon name="Bar-chart" class="projects-table-item__icon" v-if="item.project_type === 'brand_detection'"></svgicon>
              <svgicon name="Cut2" class="projects-table-item__icon" v-else></svgicon>
              <span class="acr-bold">{{item.project_name}}</span>
            </div>
            <div class="projects-info"></div>
          </div>
        </div> -->
      </el-dialog>
      <div class="frame-view__heading" v-if="video">
        <div style="display: flex;align-items: center">
          <div class="frame-view__btn" @click="$router.go(-1)">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <div class="frame-view__title acr-ultra-bold">{{video.display_name || video.video_name}}</div>
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <retrain-model
            :disabled="retrain.disabled"
            :info="retrain.info"
          />
          <model-info />
          <el-switch
            v-model="hideFilter"
            active-color="rgba(36, 49, 67, 0.1)"
            inactive-color="rgba(36, 49, 67, 0.1);"
            active-text="Watch video"
            inactive-text="Frame-by-frame">
          </el-switch>
        </div>
      </div>
      <div class="frame-view__wrapper">
        <div class="frame-view" :class="{'min': !hideFilter}" v-if="!hideFilter" @mouseover="showSlider =true" @mouseleave="showSlider = false">
          <div class="frame-view__slider" :class="{'hide': !showSlider}" v-show="!editingBox">
            <el-slider v-model="frame"
                       :show-tooltip="false"
                       :min="1"
                       :max="totalFrames">
            </el-slider>
          </div>
          <!--<video :src="video.video_url" controls :poster="video.thumbnail_url" class="frame-view__frame condensed" v-if="$route.params.type === 'video_analytics'"></video>-->
          <div class="frame-view__frame" :class="{'full': hideFilter}" ref="canvasWrapper" :key="rerender">
            <div class="frame-view__frame-overlay" :class="{'hide': !showSlider}" v-if="!editingBox"></div>

            <div  :style="`
                  position: relative;
                  background-color:rgba(38, 104, 197, 0.15);
                  width: ${canvasSettings.width}px;
                  height: ${canvasSettings.height}px;
                  transform: matrix(${scale}, 0, 0, ${scale}, ${offset.x}, ${offset.y});
                `">
              <canvas
                id="canvas"
                :width="canvasSettings.width"
                :height="canvasSettings.height"
                class="frame-view__canvas"
                ref="canvas"
              />
              <BoundingBox
                :editing-box="editingBox"
                :selected-box-id="highlightedBox"
                :width="canvasSettings.width"
                :height="canvasSettings.height"
                :boxes="frameDetects"/>
              <canvas
                id="canvasFabric"
                :width="canvasSettings.width"
                :height="canvasSettings.height"
                class="frame-view__canvas"
                ref="canvasFabric"
              />
            </div>
            <img ref="canvasImg" style="opacity:0" class="frame-view__frame-img"
                 :src="frameUrl" alt="">

          </div>
          <div class="frame-view__nav" v-if="!hideFilter">
            <div class="frame-view__btn--border" @click="downloadCanvasAsImage">
              <svgicon name="Download2"></svgicon>
            </div>
            <div class="frame-view__nav-group">
              <el-tooltip class="item" effect="light" content="Move to previous detection" placement="top" popper-class="frame-tooltip" v-if="previousDetection">
                <div class="frame-view__btn--border" @click="frame = previousDetection" >
                  <svgicon name="ArrowArcLeft" style="fill: transparent;stroke: #00204D"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="Back to first frame" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame = 1">
                  <svgicon name="Backward"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="-1 second" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame -= Math.round(video.video_fps)">
                  <svgicon name="Backward1sec"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item"  effect="light" content="-10 frames" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame -= 10">
                  <svgicon name="Backward10"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item"  effect="light" content="-1 frame" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border no-margin-right" @click="frame -= 1">
                  <svgicon name="Chevron-left"></svgicon>
                </div>
              </el-tooltip>

              <input type="number" class="acr-bold-22" v-model.number="frame">

              <el-tooltip class="item" effect="light" content="+1 frame" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border no-margin-left" @click="frame += 1">
                  <svgicon name="Chevron-right"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="+10 frames" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame += 10">
                  <svgicon name="Forward10"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="+1 second" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame += Math.round(video.video_fps)">
                  <svgicon name="Forward1sec"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="Go to the last frame" placement="top" popper-class="frame-tooltip">
                <div class="frame-view__btn--border" @click="frame = totalFrames">
                  <svgicon name="Forward"></svgicon>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="Move to next detection" placement="top" popper-class="frame-tooltip" v-if="nextDetection">
                <div class="frame-view__btn--border" @click="frame = nextDetection">
                  <svgicon name="ArrowArcRight" style="fill: transparent;stroke: #00204D"></svgicon>
                </div>
              </el-tooltip>

            </div>
            <div class="frame-view__btn--border" style="color: red" @click="openReportModal">
              <svgicon name="Union"></svgicon>
            </div>
          </div>
          <!--<div class="frame-view__nav" v-if="editingBox">-->
            <!--<div style="min-width: 50%">-->

            <!--</div>-->
            <!--<div style="display: flex">-->
              <!--<div class="frame-view__btn&#45;&#45;default frame-view__btn&#45;&#45;border" @click="finishEditingBoundingBox">-->
                <!--Cancel-->
              <!--</div>-->
              <!--<div class="frame-view__btn&#45;&#45;default frame-view__btn&#45;&#45;border" @click="finishEditingBoundingBox">-->
                <!--Save changes-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        </div>
        <video :src="video.video_url || video.original_video_url" controls :poster="video.thumbnail_url" class="frame-view" v-if="hideFilter"></video>
        <div class="filter detections" :class="{'hidden': hideFilter}" v-if="$route.params.type !== 'video_analytics'">
          <div v-if="detailsLoading" style="height: 65vh;position: relative;width: 100%;">
            <div class="loader" style="margin-left: -20px">
              <div class="square clear"></div>
              <div class="square "></div>
              <div class="square clear"></div>
              <div class="square "></div>
            </div>
            <!--<BaseLoader  />-->
          </div>
          <div v-else>
            <div class="detections-title acr-bold-18">Detections</div>
            <div style="position: relative">
              <div style="max-height: calc(100vh - 360px);overflow-y: auto;position: relative">
                <div class="detection-item" v-if="!detailsLoading && frameDetects.length === 0">No detects found</div>
                <div class="detection-item" v-if="newBoxAdded">
                  <div class="detection-item__name acr-bold" style="margin-bottom: 5px">Manual selection</div>
                  <el-input label="Brand name" v-model="brandToAssign" placeholder="Type brand name or select from a list"></el-input>
                  <el-select v-model="brandToAssign" placeholder="Select brand">
                    <el-option
                      v-for="(item, index) in brandsAvailable"
                      :key="item + index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
                <div class="detection-item"
                     v-for="detect in frameDetects"
                     @mouseleave="onBoxMouseLeave"
                     @mouseover="onBoxMouseEnter(detect)"
                     :key="detect.id">
                  <div class="detection-item__x" v-if="editingBox && editingBox.id === detect.id" @click="editBoundingBox('delete', detect)">
                    <svgicon name="Close"></svgicon>
                  </div>
                  <div class="detection-item__name acr-bold" v-if="!editingBox || editingBox.id !== detect.id">{{detect.brand}}</div>
                  <div class="detection-item__name acr-bold" v-else style="margin-bottom: 5px">
                    <el-select v-model="detect.brand" placeholder="Select brand">
                      <el-option
                        v-for="(item, index) in brandsAvailable"
                        :key="item + index"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="detection-item__area acr-regular" v-if="!editingBox || editingBox.id !== detect.id">Area: {{detect.area ? Math.round(detect.area * 100) > 1 ? Math.round(detect.area * 100) + '%' : 1 + '%' : 'calculating'}}</div>
                  <div class="detection-item__more" v-if="!editingBox || editingBox.id !== detect.id">
                    <svgicon name="More2" @click="editBoundingBox('edit', detect)"></svgicon>
                  </div>
                </div>
              </div>
              <div class="detection-new" @click="addBoundingBox" v-if="!editingBox.id && !newBoxAdded">
                <div class="detection-new__x">
                  <svgicon name="Plus"></svgicon>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="detections-btn" @click="addBoundingBox" v-if="!editingBox">
              <svgicon name="crop"></svgicon>
              <span class="acr-bold" style="margin-left: 7px;margin-top: -2px">EDIT DETECTIONS</span>
            </div>

            <div v-if="editingBox">
              <div class="detections-btn" @click="finishEditingBoundingBox">
                <svgicon name="save"></svgicon>
                <span class="acr-bold" style="margin-left: 7px;margin-top: -2px">SAVE CHANGES</span>
              </div>
              <div class="detections-btn--transparent" @click="finishEditingBoundingBox">
                <span class="acr-bold" style="margin-top: -2px">Cancel</span>
              </div>
            </div>
          </div>

        </div>
        <div class="filter detections" :class="{'hidden': hideFilter}" v-if="$route.params.type === 'video_analytics' && video && video.tags">
          <div>
            <div class="detections-title acr-bold-18">Tags</div>
            <div class="detection-item"
                 v-for="detect in video.tags"
                 @mouseleave="onBoxMouseLeave"
                 @mouseover="onBoxMouseEnter(detect)"
                 :key="detect.id">
              <div class="detection-item__name acr-bold">{{truncateString(detect, 14)}}</div>
              <div class="detection-item__more">
                <el-dropdown trigger="hover" @command="removeTag(detect)">
                  <svgicon name="More2"></svgicon>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item >Delete tag</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <div class="detections-btn" @click="addTagModal = true">ADD NEW TAG</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  getVideoById,
  getSingleFrame,
  getSingleFrameForVideoAnalytics,
  getAugmentedVideo,
  editAugumentedVideo,
  removeTag,
  getLazyFrame,
  getLazyFrameForVideoAnalytics
} from "../../api/files";
import { initCanvasFabric, removeActiveObject, addNewObjectWithCoordinates, addMouseEventListenersForDrawing } from "../../utils/canvas-fabric";
import { getDetailedProjectReport, getProjectById, getProjectFilters } from "../../api/projects";
import { addAnnotation, updateAnnotation, deleteAnnotation } from "../../api/annotations";
import { getRetrainAllowed } from "../../api/models";
import BoundingBox from '../../components/project-details/BoundingBox';
import { mapActions } from 'vuex';
import BaseLoader from '../../components/BaseLoader';
import RetrainModel from './componenets/RetrainModel';
import ModelInfo from './componenets/ModelInfo';

export default {
  name: "FrameView",
  components: {BoundingBox, BaseLoader, ModelInfo, RetrainModel},
  data() {
    return {
      loading: false,
      deleteDetectModal: false,
      nextDetection: null,
      previousDetection: null,
      showSlider: false,
      rerender: 0,
      hideFilter: false,
      frame: 1,
      frameDetects: [],
      project: null,
      addTagModal: false,
      newBoxAdded: false,
      newTag: '',
      reportClipDialog: false,
      reportReasons: [],
      clipIndex: null,
      showBackBtn: false,
      detailsLoading: true,
      frameSourceLoading: false,
      selectedBrand: [],
      brandToAssign: null,
      brandsAvailable: [],
      filters: [],
      asideFilters: [],
      tagsToAdd: [],
      highlightedBox: null,
      editingBox: false,
      video: null,
      totalFrames: 100,
      frameUrl: null,
      scale: 1.1,
      offset: {
        x: 0,
        y: 0,
      },
      canvas: {
        context: null,
      },
      canvasFabric: null,
      canvasSettings: {
        width: 300,
        height: 150
      },
      displayMode: 'augmented video',
      changeVideo: '',
      displayModesAvailable: [
        {
          label: 'Augmented video',
          value: 'augmented video'
        }
      ],
      retrain: {
        disabled: true,
        info: {},
      },
    }
  },
  watch: {
    hideFilter(v) {
      if (!v) {
        this.init().then(() => {
          this.timeout = setTimeout(() => {
            this.canvas.context = this.$refs['canvas'].getContext('2d');
            this.$refs['canvasImg'].onload = this.drawFrame;

            this.fitCanvas();
            this.drawFrame();
          }, 0);
        });
      }
    },
    frameSourceLoading(v) {
      if (v && !this.loading) {
        this.$nextTick(() => {
          this.fitCanvas();
        })
      }
    },
    frame() {
      if (this.timeout)
        clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.getFrame();
        this.getDetails();
      }, 300);
    },
    canvasSettings() {
      if (!this.loading) {
        this.fitCanvas();
        this.drawFrame();
      }
    },
    changeVideo(v) {
      this.$router.replace({ name: 'project-details', params: { projectId: this.$route.params.projectId, videoId: v, type: this.$route.params.type}});
      window.location.reload();
    },
  },
  computed: {
    isVideoAnalytics() {
      return this.$route.params.type === 'video_analytics'
    },
    projectId() {
      return this.$route.params.projectId;
    },
  },
  created() {
    this.handleRetrainAllowed();
  },
  mounted() {
    this.init().then(() => {
      setTimeout(() => {
        this.canvas.context = this.$refs['canvas'].getContext('2d');
        this.$refs['canvasImg'].onload = this.drawFrame;

        this.fitCanvas();
        this.drawFrame();
      }, 0)

    });

    window.addEventListener('boxAdded', () => { this.newBoxAdded = true }, false)
  },
  methods: {
    ...mapActions({
      success: 'success',
      error: 'error',
    }),
    async handleRetrainAllowed() {
      const { data } = await getRetrainAllowed();
      this.retrain.info = {
        message: data.msg,
        details: data.details,
      };
      if (this.retrain.disabled !== data.error) {
        this.retrain.disabled = data.error;
      }
    },
    init() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        try {
          const promiseArr = [];

          promiseArr.push(this.getProject());

          if (!this.isVideoAnalytics) {
            promiseArr.push(getVideoById(this.$route.params.videoId).then((res) => {
              this.video = res.data;
              this.canvasSettings = {
                height: res.data.video_height,
                width: res.data.video_width
              };
            }));
          } else {
            promiseArr.push(getAugmentedVideo(this.$route.params.videoId).then((res) => {
              this.video = res.data;
              this.canvasSettings = {
                height: res.data.video_height,
                width: res.data.video_width
              };
            }))
          }

          promiseArr.push(this.getDetails());

          if (this.isVideoAnalytics) {
            promiseArr.push(getProjectFilters(this.$route.params.projectId).then((res) => {
              this.filters = res.data.header_filters[0].filter_values;
              this.asideFilters = res.data.left_filters;
              this.filters = this.filters.map((item) => {
                return {label: item.replace(/_/g, ' '), value: item}
              });
            }))
          }

          Promise.all(promiseArr).then(() => {
            this.getFrame().then(() => {
              this.loading = false;
              resolve()
            });

          })
        } catch (e) {
          reject(e)
        }
      })
    },
    deleteBoundingBox() {
      removeActiveObject(this.canvasFabric);

      this.canvasFabric = null;
      this.highlightedBox = null;
      this.brandToAssign = '';

      return deleteAnnotation(this.editingBox.id, { project_id: this.projectId }).then(() => {
        this.frameDetects = this.frameDetects.filter((f) => f.id !== this.editingBox.id);
        this.newBoxAdded = false;
        this.canvasFabric = null;
        this.editingBox = false;
        this.deleteDetectModal = false;
      });
    },
    editBoundingBox(command, detect) {
      if (command === 'delete') {
        this.deleteDetectModal = true;
      }

      const editBoxWidth = Math.round(Math.abs(detect.x2 - detect.x1));
      const editBoxHeight = Math.round(Math.abs(detect.y2 - detect.y1));

      if (this.editingBox.id) {
        this.finishEditingBoundingBox();
      }

      this.editingBox = detect;
      this.brandToAssign = detect.brand;
      this.highlightedBox = detect.id;

      if (!this.canvasFabric) this.canvasFabric = initCanvasFabric('canvasFabric');
      addNewObjectWithCoordinates(this.canvasFabric, {left: detect.x1, top: detect.y1}, editBoxWidth, editBoxHeight)
    },
    addBoundingBox() {
      if (this.editingBox) {
        this.finishEditingBoundingBox();
      }
      if (!this.canvasFabric) this.canvasFabric = initCanvasFabric('canvasFabric');

      this.editingBox = {
        id: ''
      };

      addMouseEventListenersForDrawing(this.canvasFabric);
    },
    finishEditingBoundingBox() {
      const result = removeActiveObject(this.canvasFabric);

      if (!result) {
        this.canvasFabric = null;
        this.highlightedBox = null;
        this.editingBox = false;
        this.brandToAssign = '';
        return;
      }

      const resultObject = {
        x1: result.left,
        x2: result.aCoords.br.x,
        y1: result.top,
        y2: result.aCoords.br.y,
      };

      const formData = new FormData();
      Object.keys(resultObject).forEach(key => formData.append(key, resultObject[key]));

      if (!this.editingBox.id) {
        if (this.brandToAssign) {
          formData.append('project_id', this.project.id);
          formData.append('video_id', this.video.id);
          formData.append('frame_id', this.frame);
          formData.append('brand', this.brandToAssign);

          const brand = this.brandToAssign;

          addAnnotation(formData).then((res) => {
            this.frameDetects.unshift({...resultObject, brand, id: res.data.id, area: null});
            this.handleRetrainAllowed();
          });
        }
      } else {
        this.frameDetects = this.frameDetects.map((d) => {
          if (d.id === this.highlightedBox) {
            formData.append('brand', d.brand);
            formData.append('project_id', this.projectId);

            return {
              ...d,
              ...resultObject,
              brand: d.brand,
              area: null,
            }
          }
          return d
        });

        updateAnnotation(this.highlightedBox, formData);
      }

      this.canvasFabric = null;
      this.highlightedBox = null;
      this.editingBox = false;
      this.newBoxAdded = false;
      this.brandToAssign = '';
    },
    onBoxMouseLeave() {
      if (this.editingBox) return;

      this.highlightedBox = null
    },
    onBoxMouseEnter(detect) {
      if (this.editingBox) return;

      this.highlightedBox = detect.id
    },
    removeTag(tag) {
      let formD = new FormData();
      formD.append('tag', tag);
      removeTag(this.video.id, formD).then(() => {
        this.video.tags = this.video.tags.filter((t) => t !== tag);
      });
    },
    addTag(tag) {
      return new Promise((resolve, reject) => {
        let formD = new FormData();
        formD.append('tag', tag);
        editAugumentedVideo(this.video.id, formD).then(() => {
          resolve()
        }).catch(e => reject(e));
      })
    },
    addTags() {
      const promiseArr = [];

      if (this.newTag.length === 0 && this.tagsToAdd.length === 0) return;

      if (this.newTag.length) {
        this.tagsToAdd.push(this.newTag);
      }

      this.tagsToAdd.forEach(i => {
        promiseArr.push(this.addTag(i));
      });

      Promise.all(promiseArr).then(() => {
        this.newTag = '';
        this.video.tags = [...this.tagsToAdd, ...this.video.tags];
        this.tagsToAdd = [];
        this.addTagModal = false;
      })
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    downloadCanvasAsImage(){
      const link = document.createElement('a');
      link.setAttribute('download', true);
      link.download = `frame_${this.frame}.png`;
      link.href = this.frameUrl;
      link.click();
    },
    trunc(str) {
      return str.length >= 15 ? str.substring(0, 20) + '...' : str;
    },
    reportIssue() {
      if (this.reportReasons.length === 0) {
        return this.error('Select at least 1 reason');
      }

      this.reportClipDialog = false;
    },
    openReportModal() {
      this.reportClipDialog = true;
    },
    backToClip() {
      this.$router.push({ name: 'video-cutting', params: { projectId: this.$route.params.projectId, clipIndex: this.clipIndex }})
    },
    getDetails() {
      this.detailsLoading = true;
      return getDetailedProjectReport(this.$route.params.projectId, this.$route.params.videoId, this.frame).then((res) => {
        this.totalFrames = res.data.video_total_frames;
        this.frameDetects = res.data.detects;
        this.nextDetection = res.data.next_frame_detect;
        this.previousDetection = res.data.previous_frame_detect;
        this.detailsLoading = false;

        if (this.frameDetects.length > 0) {
          this.selectedBrand = [this.frameDetects[0].id];
        }
      });
    },
    getProject() {
      return getProjectById(this.$route.params.projectId).then((data) => {
        this.project = data.data;
        this.brandsAvailable = this.project.summary_report.map((item) => item.brand);
        this.getFrame();
      });
    },
    validateFrameUrl(url) {
      fetch(url).then((data) => {
        if (data.status !== 200) {
          if (this.isVideoAnalytics) {
            getLazyFrameForVideoAnalytics(this.$route.params.videoId, this.frame).then((frame) => {
              this.frameUrl = 'data:image/png;base64,' + this.binaryToBuffer(frame.data);
            });
          } else {
            getLazyFrame(this.$route.params.videoId, this.frame).then((frame) => {
              this.frameUrl = 'data:image/png;base64,' + this.binaryToBuffer(frame.data);
            });
          }
        } else {
          this.frameUrl = url
        }
      });

    },
    binaryToBuffer(str) {
      return Buffer.from(str, 'binary').toString('base64');
    },
    getFrame() {
      if (!this.project) return
      return new Promise((resolve, reject) => {
        try {

          this.frameSourceLoading = true;

          if (this.isVideoAnalytics) {

            if (!this.project.is_archived) {
              getSingleFrameForVideoAnalytics(this.$route.params.videoId, this.frame).then((frame) => {
                this.validateFrameUrl(frame.data.url);
                this.frameSourceLoading = false;
                resolve()
              })
            } else {
              getLazyFrameForVideoAnalytics(this.$route.params.videoId, this.frame).then((frame) => {
                this.frameUrl = 'data:image/png;base64,' + this.binaryToBuffer(frame.data);
                this.frameSourceLoading = false;
                resolve()
              });
            }

          } else {

            if (!this.project.is_archived) {
              getSingleFrame(this.$route.params.videoId, this.frame).then((frame) => {
                this.validateFrameUrl(frame.data.url);
                this.frameSourceLoading = false;
                resolve()
              })
            } else {
              getLazyFrame(this.$route.params.videoId, this.frame).then((frame) => {
                this.frameUrl = 'data:image/png;base64,' + this.binaryToBuffer(frame.data);
                this.frameSourceLoading = false;
                resolve()
              });
            }

          }
        } catch (e) {
          reject(e)
        }
      })
    },
    drawFrame() {
      this.frameSourceLoading = false;
      // this.canvas.context.globalCompositeOperation = 'destination-over'
      this.canvas.context.drawImage(this.$refs['canvasImg'], 0, 0, this.canvasSettings.width, this.canvasSettings.height);
    },
    handleProjectOption(key) {
      console.log(key)
    },
    handleDownloadOption(key) {
      console.log(key)
    },
    fitCanvas() {
      let w, h, scale, offset;
      w = this.$refs.canvasWrapper.offsetWidth;
      h = this.$refs.canvasWrapper.offsetHeight;
      scale = Math.min(w / this.canvasSettings.width, h / this.canvasSettings.height);
      offset = {
        x: Math.floor(w / 2 - this.canvasSettings.width / 2),
        y: Math.floor(h / 2 - this.canvasSettings.height / 2),
      };

      this.scale = scale;
      this.offset = offset;

    },
  },
}
</script>

<style scoped lang="scss">
   /deep/

   .el-checkbox {
     &-group {
       display: flex;
       flex-direction: column;
     }
     .el-checkbox__input + .el-checkbox__label {
       color: #00204D;
     }
     &.is-checked {
       .el-checkbox__inner {
         width: 17px !important;
         height: 17px !important;
         display: flex;
         align-items: center;
         justify-content: center;
         &::after {
           left: 7px;
           position: absolute;
           top: 3px;
         }
       }
     }
     &__inner {
       width: 17px !important;
       height: 17px !important;
       border: none;
       background: rgba(36, 49, 67, 0.1);
     }
   }
  /deep/
 .el-switch {
    &__label {
      font-size: 18px;
      font-family: 'AcronisCyberBold';
      color: rgba(36, 49, 67, 0.6);
      margin-top: -5px;
      &.is-active {
        color: #00204D;
      }
    }
   &__core {
     min-width: 51px;
     height: 29px;
     border: none;
     border-radius: 20px;

     &::after {
       background: #9BC225;
       border: 0.5px solid rgba(0, 0, 0, 0.04);
       box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
       width: 25px;
       height: 25px;
     }
   }
 }

  /deep/

.el-switch.is-checked .el-switch__core::after {
    margin-left: -29px;
  }

  /deep/

  .el-tooltip__popper {
    padding: 8px 10px;
    background-color: red;
  }
  .frame-tooltip {
    background-color: white;
  }

  .upper-canvas {
    position: fixed;
  }
  /deep/

   .el-select, .el-input__inner {
     width: 100%;
     color: red !important;
     input {
       width: 100%;
     }
     .el-input__suffix {
       top: 0;
     }
   }

   /deep/
   .el-input.is-focus {
     .el-input__suffix {
       top: 0;
     }


   }

   /deep/
   input, .el-input__inner {
     color: #00204D !important;
     width: 100%;
   }
</style>
